<template>
  <div class="app-layout">
    <SideBar :menuToggler="menuToggler" @closeMenu="closeMenu" />
    <div id="content" class="content">
      <div class="menu-opener" @click="toggleMenu">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <TopBar />
      <Breadcrumb />
      <slot />
    </div>
  </div>
</template>

<script>
import { SideBar, Breadcrumb, TopBar } from "@/components";
export default {
  name: "AppLayout",
  components: {
    TopBar,
    SideBar,
    Breadcrumb,
  },
  data() {
    return {
      menuToggler: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuToggler = !this.menuToggler;
    },
    closeMenu() {
      this.menuToggler = false;
    },
  },
};
</script>

<style lang="scss">
.app-layout {
  display: flex;
  background-color: var(--grayscale-10);
  min-height: 100vh;
}
.content {
  width: 100%;
  box-sizing: border-box;
  .alert-text-layout {
    font-size: 18px;
    background: red;
    color: white;
    padding: 10px;
  }
  .menu-opener {
    display: none;
  }
  @media (max-width: 820px) {
    .menu-opener {
      display: block;
      position: fixed;
      bottom: 15px;
      left: 15px;
      width: 45px;
      height: 35px;
      border-radius: 100%;
      background-color: #41807a;
      padding-top: 15px;
      z-index: 5;
      box-shadow: 0px 0px 5px;
      div {
        background-color: #fff;
        height: 3px;
        width: 20px;
        margin: 5px auto;
        border-radius: 15px;
        &:first-child {
          margin-top: 1px;
        }
      }
    }
  }
}
</style>
